var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickWithCircles = function SvgTickWithCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 76 76"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.861,
    cy: 37.861,
    r: 37.861,
    fill: "var(--icon-tick-with-circles-outer, #F69E1C)",
    opacity: "var(--icon-tick-with-circles-outer-opacity, 0.2)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.861,
    cy: 37.861,
    r: 23.756,
    fill: "var(--icon-tick-with-circles-inner, #E50C24)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--icon-tick-with-circles-mark, #FFFFFF)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M45.86 31.861 35.22 42.71a.5.5 0 0 1-.718-.004L29.86 37.86"
  })));
};
export default SvgTickWithCircles;